import { ActionsMenu, ActionsMenuItem } from '@/components/ActionsMenu';
import StopCircleIcon from '@/components/Icons/StopCircleIcon';
import TrashIcon from '@/components/Icons/TrashIcon';

import { useDeleteTrainingJob, useStopTrainingJob } from '../hooks';
import { isTrainingJobStatusInProgress } from '../utils';
import { ActionsProps } from './types';

function Actions({ trainingJob, variant }: ActionsProps) {
  // const { getPinActionItem } = usePinnedAPI();
  const stopTrainingJob = useStopTrainingJob(trainingJob.id);
  const deleteTrainingJob = useDeleteTrainingJob(trainingJob.id, trainingJob.name);

  return (
    <ActionsMenu variant={variant}>
      {/* {getPinActionItem(trainingJob.id)} */}
      {/* <Divider sx={{ mx: -1, my: 1 }} /> */}
      <ActionsMenuItem
        disabled={!isTrainingJobStatusInProgress(trainingJob.status.value)}
        destructive
        onClick={stopTrainingJob}
        icon={<StopCircleIcon />}
      >
        Stop training job
      </ActionsMenuItem>
      <ActionsMenuItem destructive onClick={deleteTrainingJob} icon={<TrashIcon />}>
        Delete training job
      </ActionsMenuItem>
    </ActionsMenu>
  );
}

export default Actions;
